import { Navigate } from 'react-router-dom';

export default function ProtectedRoute({ children, currentUser }) {
  if (currentUser === null) {
    return <Navigate to="/authent/login" replace />;
  }

  return children;
}